import React, { useEffect, useState } from "react";
import { Button, Row, Col, Spinner, Alert } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import OTPDigitInput from "@workspace/login/src/components/login-otp/OTPDigitInput";
import NavigationBar from "@workspace/jobportal/src/components/NavigationBar/NavigationBar";
import moment from "moment";
import "./CandidateUserOTP.scss";
import { useSelector } from "react-redux";
import { UseURLDataHook } from "@workspace/common";
import { login2FA, resendOTP } from "@workspace/login/src/store/actions";
import ParticlesAuth from "@workspace/login/src/ParticlesAuth";
function CandidateUserOTP() {
  document.title = "Verify OTP | Pulse";

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [timer, setTimer] = useState(0);
  const loginMeta = useSelector((state) => state.Login.login2FAMeta);
  const state = location?.state;
  const { paramObj } = UseURLDataHook.useURLData(["redirectURL"]);

  useEffect(() => {
    if (!state) {
      navigate("/candidate/login");
    }
  }, [navigate, state]);

  /**
   * OTP and User Submit
   * @param {*} values
   */
  const onOTPAndUserSubmit = (values) => {
    const optRequest = {
      otp: values.otp,
      isCandidate: true,
    };
    const redirectURLPath = paramObj?.redirectURL;
    const redirectURL = redirectURLPath
      ? `${encodeURIComponent(redirectURLPath)}`
      : null;
    dispatch(login2FA(optRequest, navigate, redirectURL));
  };

  /**
   * Formik Initialization and Validation
   */
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      otp: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .required("OTP is required")
        .matches(/^[0-9]+$/, "Must be only digits")
        .min(6, "Invalid OTP, must be 6 digits")
        .max(6, "Invalid OTP, must be 6 digits"),
    }),
    onSubmit: onOTPAndUserSubmit,
  });

  /**
   * Timer helper function
   * @param {*} timeout
   * @param {*} ms
   */
  const handleTimer = (timeout, ms) => {
    setTimer(timeout);
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(interval);
        }
        return prev - 1;
      });
    }, ms);
  };

  /**
   * Handle resend OTP and timer
   */
  const handleResendOTP = () => {
    dispatch(resendOTP(state, navigate));
    handleTimer(30, 1000);
  };

  return (
    <ParticlesAuth>
      <header className="login-navigation-bar">
        <NavigationBar />
      </header>
      <div
        className="auth-page-content bg-white d-flex align-items-center justify-content-center"
        style={{ height: "79vh" }}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="candidate-otp-container">
            <Row>
              <Col>
                <div className="h4 fw-light">Verify Your Login</div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-muted text-center">
                  <p>
                    6 digits OTP code sent to{" "}
                    <i>
                      <b>{state?.email}</b>
                    </i>
                  </p>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="d-flex flex-row h-100" style={{ gap: "10px" }}>
                  <OTPDigitInput
                    noOfOtp={6}
                    setOTP={(otp) => formik.setFieldValue("otp", otp)}
                  />
                </div>
              </Col>
              {formik.touched.otp && formik.errors.otp ? (
                <Alert
                  className="border-0 alert-danger text-center mb-2 mx-2"
                  role="alert"
                >
                  {formik.errors.otp}
                </Alert>
              ) : null}
            </Row>
            {formik.touched.otp && formik.errors.otp && (
              <Row>
                <Col>
                  <div className="invalid-feedback">{formik.errors.otp}</div>
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <Button
                  style={{ backgroundColor: "#0a65cc", color: "#fff" }}
                  disabled={loginMeta?.isLoading}
                >
                  <span style={{ marginRight: "5px" }}>Confirm</span>
                  {loginMeta?.isLoading && (
                    <Spinner size="sm">Loading...</Spinner>
                  )}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <div>
                  Didn't receive the code?{" "}
                  <span
                    className={
                      timer > 0
                        ? `cursor-not-allowed disabled`
                        : `cursor-pointer`
                    }
                    style={{
                      textDecoration: "underline",
                      color: "#0a65cc",
                      pointerEvents: timer > 0 ? "none" : "auto",
                      opacity: timer > 0 ? 0.65 : 1,
                    }}
                    onClick={handleResendOTP}
                  >
                    Resend
                  </span>
                  {timer > 0 && <span> in {timer} seconds</span>}
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </div>
      <footer className="login-footer-bar">
        <p>{moment().year()} &copy; Avensys</p>
      </footer>
    </ParticlesAuth>
  );
}

export default CandidateUserOTP;
